import { CommonModule } from '@angular/common';
import { Component, inject, input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CompanyNamePipe } from '@app/features/companies/company-name-pipe';
import { ContractFormValue } from '@app/features/contracts/embauche-dialog/embauche-tabs-form/contract-form/contract-form';
import { SchedulesFormValue } from '@app/features/contracts/embauche-dialog/embauche-tabs-form/schedules-form/schedules-form';
import { JobNamePipe } from '@app/features/job-name-pipe';
import { JobTypeService } from '@app/features/job-types/job-type-service';
import { JobType } from '@app/features/job-types/job-type.model';
import { LabelValue } from '@app/shared/forms/label-value/label-value';
import moment from 'moment';

@Component({
  selector: 'app-contract-view',
  imports: [CommonModule, LabelValue, JobNamePipe, CompanyNamePipe],
  templateUrl: './contract-view.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './contract-view.scss',
})
export class ContractView implements OnInit {
  contract = input.required<ContractFormValue>();
  schedules = input.required<SchedulesFormValue>();
  jobTypeService = inject(JobTypeService);
  jobTypes: JobType[] = [];

  ngOnInit(): void {
    this.jobTypeService.allJobTypes$.subscribe((jobTypes) => {
      this.jobTypes = jobTypes;
    });
  }

  get trialPeriodDuration(): string {
    if (this.contract().endOfFirstTrialPeriodDate) {
      const endOfFirstTrialPeriodDate = moment(this.contract().endOfFirstTrialPeriodDate);
      const start = moment(this.contract().startDate);
      const diffInDays = endOfFirstTrialPeriodDate.add(1, 'days').diff(start, 'days');
      const diffInWeeks = endOfFirstTrialPeriodDate.add(1, 'days').diff(start, 'weeks');
      return `${diffInWeeks} sem. (${diffInDays} j)`;
    } else {
      return 'N/D';
    }
  }
}
